import { ProductFormVariantSelect } from '../qf/productFormVariantSelect';

export class ClientVariantSelect extends ProductFormVariantSelect {
    constructor(product_json, section_id, enable_history) {
        super(product_json, section_id, enable_history);

        this.compare_at_price_el = "[product-max-total]";
    }

    selectCallback(variant, selector) {
        // Call the parent class's selectCallback method
        super.selectCallback(variant, selector);

        // Additional function to run when selectCallback is called
        //this.testMethod(variant);
    }

    testMethod(variant) {
        console.log('Test method - variant name: ',variant.name);
    }

}

// Override the global ProductFormVariantSelect reference with the extended class
window.ProductFormVariantSelect = ClientVariantSelect;